<template>
  <div class="pb-5">
    <div class="foot-gradient"></div>
    <div class="footwrap">
      <div class="line"></div>
      <div class="row d-flex justify-content-center justify-content-md-between mt-5 text-center text-sm-left">
          <div class="col-12 col-md-2 mb-5 mb-lg-0 d-flex justify-content-center">
            <div class="d-flex flex-column">
              <router-link to="/" @click.native="scrollToTop()">
                <img src="~@/assets/img/logo.svg" alt="amio logo" width="139px" height="47px">
              </router-link>
              <div class="d-flex mt-4 justify-content-center justify-content-md-start">
                <a href="https://www.linkedin.com/company/amio.io" target="_blank">
                  <img class="social-icon" src="~@/assets/img/social/linkedin_gray.svg" alt="linkedin">
                </a>
                <a class="ml-3" href="mailto:support@amio.io">
                  <div class="social-icon d-flex">
                    <img class="my-auto" src="~@/assets/img/social/email.svg" alt="linkedin" height="16px">
                  </div>
                </a>

              </div>
            </div>
          </div>

        <div class="row col-12 col-md-10 col-lg-8 justify-content-center justify-content-md-end">
          <div class="col-sm-3 pl-lg-5">
            <div class="justify-content-center">
              <div class="footer-headline mb-4">Product</div>
              <div class="item">
                <router-link to="/product" @click.native="scrollToTop()" class="menu-text">
                  Product
                </router-link>
              </div>
              <div class="item mt-3">
                <a href="https://automate.amio.io/login" class="menu-text">
                  Login
                </a>
              </div>
            </div>
          </div>

          <div class="col-sm-3 mt-4 mt-sm-0">
            <div class="footer-headline mb-4">Developers</div>
            <div class="item mb-3"><a href="https://docs.amio.io/" target="_blank" class="menu-text">Documentation</a>
            </div>
            <div class="item mb-3"><a href="https://docs.amio.io/v1.0/reference" target="_blank" class="menu-text">API
              Reference</a></div>
            <div class="item mb-3"><a href="https://github.com/amio-io/amio" target="_blank" class="menu-text">SDKs</a>
            </div>
            <div class="item"><a href="https://stats.uptimerobot.com/ANyMkCJ54/" target="_blank" class="menu-text">Status</a></div>
          </div>

          <div class="col-sm-3 mt-4 mt-sm-0">
            <div class="footer-headline mb-4">Company</div>
            <div class="item mb-3">
              <a href="https://blog.amio.io" target="_blank" class="menu-text">
                Blog
              </a>
            </div>
            <div class="item">
              <router-link to="/contact-us" class="menu-text">
                Contact
              </router-link>
            </div>
          </div>

          <div class="col-sm-3 mt-4 mt-sm-0">
            <div class="footer-headline mb-4">Legal</div>
            <div class="item mb-3">
              <router-link to="/privacy-notice" @click.native="scrollToTop()" class="menu-text">
                Privacy Notice
              </router-link>
            </div>
            <div class="item mb-3">
              <router-link to="/terms-of-services" @click.native="scrollToTop()" class="menu-text">
                Terms of Services
              </router-link>
            </div>
            <div class="item">
              <router-link to="/cookies" @click.native="scrollToTop()" class="menu-text">
                Cookies
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import analyticsMixin from '@/mixins/analytics.mixin'

  export default {
    name: 'Footer',
    mixins: [analyticsMixin],
    data() {
      return {
        showDropdown: true
      }
    },
    methods: {
      trackSignup: function () {
        this.trackSignup()
      },
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/bootstrap/variables.scss";
  .footwrap {
    font-weight: 300;
    font-size: 0.9em;
  }
  .footer-headline {
    font-weight: 600;
  }
  .menu-text {
    color: #303235;
  }
  .menu-text:hover {
    color: $primary;
  }

  .social-icon {
    height: 20px;
  }
  .social-icon:hover {
    opacity: 0.8;
  }
</style>
